<template>
    <div>
<!--body content start-->

<div id="main-page" class="page-content">

<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-9 col-md-12 order-lg-1">
        <div class="row mb-4 align-items-center">          
          <div class="col-md-5 mb-3 mb-md-0">
            <span class="text-muted">Showing 1 to 18 of 20 total</span>
          </div>
          <div class="col-md-7 d-flex align-items-center justify-content-md-end">
            <div class="view-filter">
                <router-link tag='a' class="active" to="product-grid"><i class="flaticon-squares"></i></router-link>
                <router-link to="product-list" tag='a'><i class="flaticon-list"></i></router-link>
            </div>
            <div class="sort-filter mr-2 d-flex align-items-center">
              <select>
                <option>Default Sorting</option>
                <option>Newest Item</option>
                <option>Populer</option>
              </select>
            </div>            
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="product-item">
              <div class="product-img">
                <img class="img-fluid" src="images/product/01.jpg" alt="">
                <div class="product-overlay">
                  <ul class="list-inline">
                    <li>
                      <a href="#"> <i class="far fa-heart"></i>
                      </a>
                    </li>
                    <li> <a href="#">Add To Cart <i class="fas fa-shopping-bag ml-1"></i>
                  </a> 
                    </li>
                    <li>
                      <a href="#"> <i class="far fa-eye"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="product-desc"> <a href="product-single.html" class="product-name">Women T-Shirt</a>
                <div class="product-price">$15.00 <span>$22.00</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 mt-5 mt-md-0">
            <div class="product-item">
              <div class="product-img">
                <img class="img-fluid" src="images/product/02.jpg" alt="">
                <div class="sale-label">Sale</div>
                <div class="product-overlay">
                  <ul class="list-inline">
                    <li>
                      <a href="#"> <i class="far fa-heart"></i>
                      </a>
                    </li>
                    <li> <a href="#">Add To Cart <i class="fas fa-shopping-bag ml-1"></i>
                  </a> 
                    </li>
                    <li>
                      <a href="#"> <i class="far fa-eye"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="product-desc"> <a href="product-single.html" class="product-name">Watch</a>
                <div class="product-price">$28.00 <span>$35.00</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 mt-5 mt-lg-0">
            <div class="product-item">
              <div class="product-img">
                <img class="img-fluid" src="images/product/03.jpg" alt="">
                <div class="product-overlay">
                  <ul class="list-inline">
                    <li>
                      <a href="#"> <i class="far fa-heart"></i>
                      </a>
                    </li>
                    <li> <a href="#">Add To Cart <i class="fas fa-shopping-bag ml-1"></i>
                  </a> 
                    </li>
                    <li>
                      <a href="#"> <i class="far fa-eye"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="product-desc"> <a href="product-single.html" class="product-name">Goggles</a>
                <div class="product-price">$12.00 <span>$20.00</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 mt-5">
            <div class="product-item">
              <div class="product-img">
                <img class="img-fluid" src="images/product/04.jpg" alt="">
                <div class="sale-label">New</div>
                <div class="product-overlay">
                  <ul class="list-inline">
                    <li>
                      <a href="#"> <i class="far fa-heart"></i>
                      </a>
                    </li>
                    <li> <a href="#">Add To Cart <i class="fas fa-shopping-bag ml-1"></i>
                  </a> 
                    </li>
                    <li>
                      <a href="#"> <i class="far fa-eye"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="product-desc"> <a href="product-single.html" class="product-name">Men's Shoes</a>
                <div class="product-price">$45.00 <span>$75.00</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 mt-5">
            <div class="product-item">
              <div class="product-img">
                <img class="img-fluid" src="images/product/05.jpg" alt="">
                <div class="product-overlay">
                  <ul class="list-inline">
                    <li>
                      <a href="#"> <i class="far fa-heart"></i>
                      </a>
                    </li>
                    <li> <a href="#">Add To Cart <i class="fas fa-shopping-bag ml-1"></i>
                  </a> 
                    </li>
                    <li>
                      <a href="#"> <i class="far fa-eye"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="product-desc"> <a href="product-single.html" class="product-name">Bag</a>
                <div class="product-price">$25.00 <span>$40.00</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 mt-5">
            <div class="product-item">
              <div class="product-img">
                <img class="img-fluid" src="images/product/06.jpg" alt="">
                <div class="product-overlay">
                  <ul class="list-inline">
                    <li>
                      <a href="#"> <i class="far fa-heart"></i>
                      </a>
                    </li>
                    <li> <a href="#">Add To Cart <i class="fas fa-shopping-bag ml-1"></i>
                  </a> 
                    </li>
                    <li>
                      <a href="#"> <i class="far fa-eye"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="product-desc"> <a href="product-single.html" class="product-name">Ballerina</a>
                <div class="product-price">$38.00 <span>$44.00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <nav aria-label="Page navigation" class="mt-5">
          <ul class="pagination">
            <li class="page-item"><a class="page-link" href="#"><i class="fas fa-arrow-right"></i></a>
            </li>
            <li class="page-item active"><a class="page-link" href="#">1</a>
            </li>
            <li class="page-item"><a class="page-link" href="#">2</a>
            </li>
            <li class="page-item"><a class="page-link" href="#">3</a>
            </li>
            <li class="page-item"><a class="page-link" href="#"><i class="fas fa-arrow-left"></i></a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-lg-3 col-md-12 sidebar mt-5 mt-lg-0">
        <div class="widget">
          <h5 class="widget-title">Categories</h5>
          <ul class="widget-categories list-unstyled">
            <li> <a href="#"><i class="fas fa-angle-left ml-1"></i> All</a>
            </li>
            <li> <a href="#"><i class="fas fa-angle-left ml-1"></i> Men’s Fashion</a>
            </li>
            <li> <a href="#"><i class="fas fa-angle-left ml-1"></i> Women’s Fashion</a>
            </li>
            <li> <a href="#"><i class="fas fa-angle-left ml-1"></i> Kid's Fashion</a>
            </li>
            <li> <a href="#"><i class="fas fa-angle-left ml-1"></i> New Arrivals</a>
            </li>
            <li> <a href="#"><i class="fas fa-angle-left ml-1"></i> Accessories</a>
            </li>
          </ul>
        </div>
        <div class="widget">
          <h5 class="widget-title">Price</h5>
          <div>
            <div id="slider-range"></div>
            <input type="text" id="amount" readonly style="border:0;">
          </div>
        </div>
        <div class="widget filter-color">
          <h5 class="widget-title">Color</h5>
          <ul class="list-inline">
            <li>
              <div class="form-check pl-0">
                <input type="radio" class="form-check-input" id="color-filter1" name="ExampleRadios">
                <label class="form-check-label" for="color-filter1" data-bg-color="#3cb371"></label>
              </div>
            </li>
            <li>
              <div class="form-check pl-0">
                <input type="radio" class="form-check-input" id="color-filter2" name="ExampleRadios" checked>
                <label class="form-check-label" for="color-filter2" data-bg-color="#4876ff"></label>
              </div>
            </li>
            <li>
              <div class="form-check pl-0">
                <input type="radio" class="form-check-input" id="color-filter3" name="ExampleRadios">
                <label class="form-check-label" for="color-filter3" data-bg-color="#0a1b2b"></label>
              </div>
            </li>
            <li>
              <div class="form-check pl-0">
                <input type="radio" class="form-check-input" id="color-filter4" name="ExampleRadios">
                <label class="form-check-label" for="color-filter4" data-bg-color="#f94f15"></label>
              </div>
            </li>
            <li>
              <div class="form-check pl-0">
                <input type="radio" class="form-check-input" id="color-filter5" name="ExampleRadios">
                <label class="form-check-label" for="color-filter5" data-bg-color="#e70fe4"></label>
              </div>
            </li>
            <li>
              <div class="form-check pl-0">
                <input type="radio" class="form-check-input" id="color-filter6" name="ExampleRadios">
                <label class="form-check-label" for="color-filter6" data-bg-color="#ffc300"></label>
              </div>
            </li>
          </ul>
        </div>
        <div class="widget">
          <h5 class="widget-title">Size</h5>
          <div class="size-choose">
            <ul class="list-inline">
              <li>
                <input name="sc" id="s-size" type="radio">
                <label for="s-size">S</label>
              </li>
              <li>
                <input name="sc" id="m-size" checked="" type="radio">
                <label for="m-size">M</label>
              </li>
              <li>
                <input name="sc" id="l-size" type="radio">
                <label for="l-size">L</label>
              </li>
              <li>
                <input name="sc" id="xl-size" type="radio">
                <label for="xl-size">XL</label>
              </li>
              <li>
                <input name="sc" id="xxl-size" type="radio">
                <label for="xxl-size">XXL</label>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

</div>

<!--body content end--> 
    </div>
</template>

<script>

export default {
    data: function () {
        return {
            name: 'Product Grid'
        }
    },
};
</script>
